import React from 'react';
export function HeroSection() {
  return <section className="bg-gradient-to-b from-[#0B1A2E] to-[#0F2341] py-16 md:py-24 px-4 text-center" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        <div className="inline-block bg-[#D4A843]/20 border border-[#D4A843]/50 text-[#F0C14B] px-4 py-1.5 rounded-full text-sm font-bold tracking-wider mb-8 uppercase" data-id="element-35">
          🚀 PARA PROFES DE EDUCACION FISICA Método A.C.C.I.Ó.N.
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-10 text-balance" data-id="element-36">
          ¿Llegás al domingo a la noche sin saber qué vas a dar el lunes?
        </h1>

        <div className="relative mx-auto mb-10 rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/10" data-id="element-37">
          <img src="https://cdn.magicpatterns.com/uploads/sA5yFt7aYa5kXa6rxVUg1V/Coleccion_A.C.C.I.O.N..png" alt="Método A.C.C.I.Ó.N. - El Sistema Blindado de Planificación para Profesores de Educación Física" className="w-full h-auto object-cover" data-id="element-38" />
        </div>

        <p className="text-xl md:text-2xl text-gray-300 leading-relaxed font-medium max-w-3xl mx-auto text-balance" data-id="element-39">
          El <strong className="text-[#F0C14B]" data-id="element-40">Método A.C.C.I.Ó.N.</strong> es
          el sistema que te permite planificar cualquier clase de Educación
          Física en 10 minutos — con estructura pedagógica real, sin improvisar
          y sin gastar tus domingos frente a una hoja en blanco.
        </p>
      </div>
    </section>;
}